import { Link } from 'react-router-dom';
import { useSettings } from '@/context/SettingsContext';

/**
 * Responsive hero banner. Reads settings.hero_banner. Fully responsive.
 * Auto-hides when disabled or when there's no image.
 */
export default function HeroBanner() {
  const { settings } = useSettings();
  const hb = settings?.hero_banner;
  if (!hb || !hb.enabled || !hb.image_url) return null;

  const hasText = hb.title || hb.subtitle;
  const btn = hb.button_text && hb.button_link;

  return (
    <section
      data-testid="hero-banner"
      className="relative rounded-3xl overflow-hidden bg-stone-100"
    >
      <img
        src={hb.image_url}
        alt={hb.title || 'Hero banner'}
        className="block w-full h-auto max-h-[520px] object-cover"
        loading="eager"
        decoding="async"
      />
      {(hasText || btn) && (
        <div className="absolute inset-0 flex flex-col justify-center px-5 sm:px-10 lg:px-16 bg-gradient-to-r from-black/45 via-black/10 to-transparent">
          {hb.title && (
            <h1
              data-testid="hero-banner-title"
              className="font-heading text-white text-2xl sm:text-4xl lg:text-5xl leading-tight max-w-[65%] drop-shadow-md"
            >
              {hb.title}
            </h1>
          )}
          {hb.subtitle && (
            <p
              data-testid="hero-banner-subtitle"
              className="mt-2 text-white/95 text-sm sm:text-base lg:text-lg max-w-[60%] drop-shadow"
            >
              {hb.subtitle}
            </p>
          )}
          {btn && (
            <div className="mt-4">
              {hb.button_link.startsWith('http') ? (
                <a
                  href={hb.button_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="hero-banner-cta"
                  className="inline-flex items-center h-11 px-6 rounded-full bg-white text-stone-900 font-semibold shadow-lg hover:bg-stone-100 transition-colors"
                >
                  {hb.button_text}
                </a>
              ) : (
                <Link
                  to={hb.button_link}
                  data-testid="hero-banner-cta"
                  className="inline-flex items-center h-11 px-6 rounded-full bg-white text-stone-900 font-semibold shadow-lg hover:bg-stone-100 transition-colors"
                >
                  {hb.button_text}
                </Link>
              )}
            </div>
          )}
        </div>
      )}
    </section>
  );
}
